import React from 'react';
import { useNavigate } from 'react-router-dom';
import SimplePageLayout from '../../../layouts/simple-page-layout/SimplePageLayout';
import CreateAgencyWizard from '../../containers/create-agency-wizard/CreateAgencyWizard';
import { Agency } from '../../../providers/api/dtos';

const CreateAgencyPage: React.FC = () => {
  const navigate = useNavigate();

  const goToAgencyPage = React.useCallback((agency: Agency) => {
    navigate(`/agencies/${agency.id}`, {
      replace: true,
    });
  }, [navigate]);

  return (
    <SimplePageLayout wrapperSize="M">
      <CreateAgencyWizard onFinish={goToAgencyPage} />
    </SimplePageLayout>
  );
};

export default CreateAgencyPage;
